<app-menu></app-menu>

<div class="appContentsContainer">
  <form
    class="formGroup container halfForm wrapHalfRows ng-untouched ng-pristine ng-valid"
  >
    <div class="pageTitle">Placa constructor</div>

    <div class="fullGroup">
      <div class="collapsibleTitle pageTitle">
        <div class="collapseButtonContainer">
          <button
            type="button"
            *ngIf="!sectionHidden.placa"
            class="submitSearchButton"
            (click)="sectionHidden.placa = !sectionHidden.placa"
          >
            <em class="fas fa-angle-up"></em>
          </button>

          <button
            type="button"
            *ngIf="sectionHidden.placa"
            class="submitSearchButton"
            (click)="sectionHidden.placa = !sectionHidden.placa"
          >
            <em class="fas fa-angle-down"></em>
          </button>

          <div class="pageTitle collapsibleTitle">
            <div class="title halfTitle">Consulta de datos placa</div>
          </div>
        </div>
      </div>

      <div *ngIf="!sectionHidden.placa" class="reponsiveWidthComentarios">
        <app-form-fields [fields]="fieldsPlaca"></app-form-fields>
      </div>
    </div>

    <div class="consultaEditarButtonGroup">
      <div class="backButton">
        <button class="formButton" type="button" (click)="goList()">
          <em class="fas fa-chevron-left"></em>
        </button>
      </div>
    </div>
  </form>
</div>
